import { SearchIcon } from "@heroicons/react/solid"
import Button from "components/button"
import Input from "components/input"
import Select from "components/select";
import { useState } from "react";
import { BLOG_STATUS_OPTION, BLOG_SUB_CATEGORY_TYPE } from "utills/constants";

const ALL_OPTION = { label: "All", value: "" };

export const Filter = ({ currentFilterValues, setFilters}: {currentFilterValues: any, setFilters: any}) => {
  const statusIds = [ALL_OPTION].concat(BLOG_STATUS_OPTION);
  const categoryIds = [ALL_OPTION].concat(BLOG_SUB_CATEGORY_TYPE);
  const _handleSubmitFilter = () => {
    setFilters([
      {field: "q", operator: "contains", value: keyword},
      {field: "category", operator: "eq", value: categoryId},
      {field: "status", operator: "eq", value: status},
      {field: "page", operator: "eq", value: 1}
    ])
  }

  const [keyword, setKeyword] = useState(currentFilterValues.q);
  const [categoryId, setCategoryId] = useState(currentFilterValues.category);
  const [status, setStatus] = useState(currentFilterValues.status);
  return (
    <div className="w-full flex flex-col gap-y-4 md:flex-row md:items-end md:gap-x-3">
      <div className="flex-1">
        <label htmlFor="name" className="block text-sm font-medium leading-6">
          Search
        </label>
        <div className="mt-2">
          <Input 
            className="px-2 py-2"
            label='Search'
            id='name'
            type="text"
            placeholder="Search by sub categories"
            value={keyword}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setKeyword(e.target.value)}
            onKeyDown={(e: React.KeyboardEvent) => {
              if (e.key === 'Enter') {
                _handleSubmitFilter();
              }
            }}
          />
        </div>
      </div>
      <div className="flex-1">
        <label htmlFor="category" className="block text-sm font-medium leading-6">
          Category
        </label>
        <div className="mt-2">
          <Select
            options={categoryIds}
            id="category"
            placeholder="Select Category"
            className="py-0.5"
            value={categoryIds.find((d) => d.value === categoryId)}
            onChange={(selected: {label: string; value: string}) => setCategoryId(selected?.value)}
          />
        </div>
      </div>
      <div className="flex-1">
        <label htmlFor="status" className="block text-sm font-medium leading-6">
          Status
        </label>
        <div className="mt-2">
          <Select
            options={statusIds}
            id="status"
            placeholder="Select Status"
            className="py-0.5"
            value={statusIds.find((d) => d.value === status)}
            onChange={(selected: {label: string; value: string}) => setStatus(selected?.value)}
          />
        </div>
      </div>
      <div className="shrink-0">
        <label htmlFor="status" className="block text-sm font-medium leading-6">
          <span className="sr-only">Search</span>
        </label>
        <div className="mt-2 w-full">
          <Button type="submit" className="w-full bg-white rounded-md px-3 text-brand-500 py-2 border-solid border-brand-500 border-[1px] hover:bg-white active:bg-white active:opacity-85" onClick={_handleSubmitFilter}>
            <SearchIcon className="w-3 h-4 text-brand-500 mr-2" /> Search
          </Button>
        </div>
      </div>
    </div>
  )
}